import { toBool, WorkflowGroup } from 'vopay';
import { useState } from 'react';
import apiConfig from '@/services/api.config';
import { usePermissions } from '@/providers/Permissions.provider';
import { useClientData } from '@/providers/ClientData.provider';

const { api } = apiConfig;

export default function useFetchWorkflows() {
  const [workflows, setWorkflows] = useState<WorkflowGroup[]>([]);
  const [fetchingWorkflows, setFetchingWorkflows] = useState(false);
  const { permissions } = usePermissions();

  const {
    response: { TransactionApprovalWorkflowEnabled },
  } = useClientData();

  async function fetchWorkflows() {
    if (!permissions.ViewTransactionApprovalWorkflow || !toBool(TransactionApprovalWorkflowEnabled)) {
      return;
    }

    try {
      setFetchingWorkflows(true);
      const res = await api.fetchWorkflows();

      if (!res.Success) throw new Error(res.ErrorMessage);
      setWorkflows(res.Workflows);
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingWorkflows(false);
    }
  }

  return {
    workflows,
    fetchWorkflows,
    fetchingWorkflows,
  };
}
